import axios from "@/plugins/axios";

let url = "/api/console/nshop/statistics";

/**
 * @typedef {object} $NshopStatisticItem
 *
 * @property {string} title
 *
 * @property {object} order
 * @property {number} order.count
 * @property {number} order.sales
 *
 * @property {object} message
 *
 * @property {object} message.kakao
 * @property {number} message.kakao.count
 *
 * @property {object} message.plain
 * @property {number} message.plain.count
 */

export const statistics = {
    /**
     * @param {import("axios").AxiosRequestConfig} data
     * @returns {Promise<{ summary: { totalCount: number }, statistics: $NshopStatisticItem[]}>}
     */
    gets(data) {
        return axios.get(url, data).then((result) => result.data);
    },
};

export default statistics;
